import Icon from 'veui/components/Icon'
import { IconTrophy } from 'dls-icons-vue'

Icon.register('trophy', IconTrophy)
